export default "<!-- vue hook -->\n<!-- ko stopBinding: true -->\n<div id=\"adminVueWrapper\">\n<div id=\"adminApp\"></div>\n</div>\n<!-- /ko -->\n";